import { computed, getCurrentInstance } from 'vue-demi';
import { AppRouter } from '@/common';

/** Should not be used directly in components! Use specific module with named query param instead */
export const useRouter = () => {
  const vm = getCurrentInstance()!;
  const bindInternalRouter = () => {
    AppRouter.bind(vm.proxy);
  };

  return {
    query: computed(() => vm.proxy.$route.query),
    route: computed(() => vm.proxy.$route),
    AppRouter,
    bindInternalRouter,
  };
};
